import React from "react";
import { Link } from "react-router-dom";

const ServicesSidebar = ({ activeTab }) => {
  const Tabs = [
    { key: "distribution", label: "Distribution" },
    { key: "playout", label: "Playout" },
    { key: "creative", label: "Creative" },
    { key: "cloud", label: "Cloud" },
    { key: "satellite-iot", label: "Satellite & IoT" },
    { key: "network", label: "Network" },
    { key: "asst-mgmt", label: "Asst Mgmt" },
    { key: "teleport", label: "Teleport" },
  ];
  return (
    <aside className="services-sidebar">
      <div className="services-sidebar-tabs">
        {Tabs.map((tab) => (
          <Link
            className={`services-sidebar-tab ${
              tab.key === activeTab ? "active" : ""
            }`}
            to={`/services/${tab.key}`}
            key={tab.key}
          >
            <span>{tab.label}</span>
          </Link>
        ))}
      </div>
    </aside>
  );
};

export default ServicesSidebar;
